import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';

/**
 * Temporary developer-only switch for testing Measure dialogs without hardware.
 * Remove this component and its single usage in BatchMeasureMaterialDialogComponent
 * when barcode scanner and scale-free testing is no longer needed.
 */
@Component({
  selector: 'app-developer-measure-override',
  standalone: true,
  templateUrl: './developer-measure-override.component.html',
  styleUrls: ['./developer-measure-override.component.css']
})
export class DeveloperMeasureOverrideComponent {
  @Input() disabled = false;
  @Output() readonly manualEntryChange = new EventEmitter<boolean>();

  readonly available = environment.enableDeveloperMeasureOverride;
  manualEntryEnabled = false;

  toggle(): void {
    if (!this.available || this.disabled) {
      return;
    }

    this.manualEntryEnabled = !this.manualEntryEnabled;
    this.manualEntryChange.emit(this.manualEntryEnabled);
  }
}
